import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Store, X, ArrowRight } from "lucide-react";

// Gentle, dismissable nudge for vendors: completing profile/hours helps them
// appear better in search and attract more customers. Not blocking.
export default function StoreSuggestionBanner({ vendor }) {
  const navigate = useNavigate();
  const vid = vendor?.vendor_id;
  const flag = vid ? `kn_storesuggest_${vid}` : null;
  const [dismissed, setDismissed] = useState(() => (flag ? localStorage.getItem(flag) === "1" : false));

  const { show, missing, pct } = useMemo(() => {
    if (!vendor || !vendor.store_name) return { show: false, missing: [], pct: 0 };
    const m = [];
    if (!vendor.hours && !(vendor.hours_struct && vendor.hours_struct.length)) m.push("orari");
    if (!vendor.logo) m.push("logo");
    if (!vendor.cover_photo) m.push("foto di copertina");
    if (!vendor.description) m.push("descrizione");
    if (!vendor.category || vendor.category === "altro") m.push("categoria");
    const total = 6; // store_name + 5 checks
    const done = total - m.length;
    return { show: m.length > 0, missing: m, pct: Math.round((done / total) * 100) };
  }, [vendor]);

  if (!show || dismissed) return null;

  const dismiss = () => { if (flag) localStorage.setItem(flag, "1"); setDismissed(true); };
  const missingLabel = missing.slice(0, 3).join(", ");

  return (
    <div data-testid="store-suggestion-banner" className="relative overflow-hidden rounded-2xl border border-[#E63946]/15 bg-gradient-to-br from-[#FFF1F2] to-white p-4 pr-10 flex items-center gap-3">
      <div className="h-11 w-11 rounded-xl kn-gradient grid place-items-center shrink-0 shadow-sm">
        <Store className="h-5 w-5 text-white" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-extrabold text-slate-900 leading-tight">Fatti trovare più facilmente</p>
        <p className="text-sm text-slate-600 mt-0.5">
          Completa {missingLabel ? <>({missingLabel}) </> : null}il profilo del negozio: con orari, foto e descrizione appari meglio nelle ricerche e attiri più clienti.
        </p>
        <div className="mt-2 max-w-[280px]">
          <p className="text-xs font-bold text-slate-500">Profilo negozio completo al {pct}%</p>
          <div className="mt-1 h-1.5 w-full rounded-full bg-slate-200 overflow-hidden">
            <div className="h-full kn-gradient rounded-full transition-all duration-500" style={{ width: `${pct}%` }} />
          </div>
        </div>
        <button data-testid="store-suggestion-cta" onClick={() => navigate("/vendor/store")}
          className="mt-2 inline-flex items-center gap-1.5 text-sm font-bold text-[#E63946] hover:underline">
          Completa il negozio <ArrowRight className="h-4 w-4" />
        </button>
      </div>
      <button data-testid="store-suggestion-dismiss" onClick={dismiss} aria-label="Chiudi"
        className="absolute top-2.5 right-2.5 h-7 w-7 rounded-full hover:bg-black/5 grid place-items-center text-slate-400">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
